module.exports = __webpack_public_path__ + "img/01_uk.960bc652.svg";